import React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Box, IconButton } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

function Header({ columns, sortBy, setSortBy, options }) {
  const getColor = (item, order) => {
    if (
      sortBy.filter((column) => column.column === item.id)[0]?.order === order
    ) {
      return "primary.main";
    }
  };

  const handleSortButtonClick = (item) => {
    const copyState = [...sortBy];
    const oldOrder = copyState.filter((column) => column.column === item.id)[0]
      ?.order;

    const itemOldIndex = copyState.findIndex(
      (column) => column.column === item.id
    );

    if (!oldOrder) {
      copyState.push({
        column: item.id,
        order: "asc",
      });
    } else if (oldOrder === "asc") {
      copyState.push({
        column: item.id,
        order: "desc",
      });

      copyState.splice(itemOldIndex, 1);
    } else if (oldOrder === "desc") {
      copyState.splice(itemOldIndex, 1);
    }

    setSortBy(copyState);
  };

  return (
    <TableHead
      sx={{
        // display: "flex",
        // justifyContent: "spaceAround",
        width: "100%",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <TableRow
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "spaceAround",
        }}
      >
        {options?.dragable && <TableCell sx={{ width: "18px" }} />}
        {columns?.map((item) => {
          if (item.view === false) {
            return null;
          } else {
            return (
              <TableCell
                sx={{
                  minWidth: item.minWidth || options.minColumnWidth || "150px",
                  width: "100%",
                  backgroundColor: "white",
                }}
                align={item.align || "left"}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "start",
                  }}
                >
                  {item.name}
                  {options.sortable && (
                    <IconButton
                      size="small"
                      sx={{ display: "flex", flexDirection: "row" }}
                      onClick={() => handleSortButtonClick(item)}
                    >
                      <ArrowUpwardIcon
                        fontSize="10"
                        sx={{ color: getColor(item, "desc") }}
                      />
                      <ArrowDownwardIcon
                        fontSize="10"
                        sx={{ color: getColor(item, "asc") }}
                      />
                    </IconButton>
                  )}
                </Box>
              </TableCell>
            );
          }
        })}

        <TableCell
          sx={(theme) => ({
            minWidth:
              options.actionsMinWidth || options.minColumnWidth || "170px",
            width: "100%",
            backgroundColor: "white",
            [theme.breakpoints.up("md")]: {
              position: "sticky",
              right: 0,
            },
            borderLeft: "dotted 1px gray",
          })}
          align={"left"}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "start",
            }}
          >
            Actions
          </Box>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default Header;
